import { TimeMaterialId } from './TimeMaterialResponse';
import { TMChangeOrderResponse } from './TMChangeOrderResponse';
import { TMVendorInvoiceResponse } from './TMVendorInvoiceResponse';

export type TMInvoiceScheduleId = string;

export interface TMInvoiceScheduleResponse {
  id: TMInvoiceScheduleId;
  title: string;
  description: string;
  percentage: number;
  isPay: boolean;
  depositUrl:string;
  amount: number;
  dueDate: number | null;
  changeOrders: Pick<TMChangeOrderResponse, 'id' | 'title' | 'total'>[];
  vendorInvoices: TMVendorInvoiceResponse[];
  status: TmInvoiceScheduleStatus;
}


export enum TmInvoiceScheduleStatus {
  sent = '1',
  dueSoon = '2',
  overDue = '3',
  paid = '4',
}
